module.exports = __webpack_public_path__ + "static/media/ABELCoaches_Denmark.afaec240.png";